import { useState } from "react";
import { EyeIcon } from "../assests/svg/SvgIcons";
import { check_email, send_signup_otp } from "../api/serverWrapper";

const EmailSignup = ({ setEmailMode, setSignupEmail, setSignupPassWord }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const [errors, setErrors] = useState({});

  // ================= VALIDATION =================

  const validate = () => {
    const newErrors = {};

    // Email
    if (!email) {
      newErrors.email = "Email is required";
    } else if (!/^\S+@\S+\.\S+$/.test(email)) {
      newErrors.email = "Enter valid email";
    }

    // Password
    if (!password) {
      newErrors.password = "Password is required";
    } else if (password.length < 6) {
      newErrors.password = "Password must be at least 6 characters";
    }

    // Confirm Password
    if (!confirmPassword) {
      newErrors.confirmPassword = "Confirm your password";
    } else if (password !== confirmPassword) {
      newErrors.confirmPassword = "Passwords do not match";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // ================= SUBMIT =================

  const handleSubmit = async () => {
    if (!validate()) return;
    setLoading(true); // 🔄 start spinner
    console.log({
      email,
      password,
    });

    try {
      // Save email for OTP screen

      let checkemail = await check_email(email);
      console.log(checkemail);

      if (!checkemail.success) {
        alert("Email already Registerd Please Login ");
        setEmailMode("login");
        return;
      } else {
        let otpData = {
          Email: email,
        };
        let res = await send_signup_otp(otpData);
        console.log(res);
        if (res?.success) {
          setSignupEmail(email);
          setSignupPassWord(password);

          // Switch to OTP screen
          setEmailMode("otp");
        }
      }
    } catch {
      alert("Failed to send OTP");
    } finally {
      setLoading(false); // ✅ stop spinner always
    }

    // call API here
  };

  return (
    <div className="email-card">
      <h2>Email Signup</h2>

      {/* Email */}
      <div className="email-field">
        <label>Email ID</label>
        <input
          type="email"
          placeholder="Email ID"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        {errors.email && <small className="error-text">{errors.email}</small>}
      </div>

      {/* Password */}
      <div className="email-field password-wrapper">
        <label>Password</label>

        <input
          type={showPassword ? "text" : "password"}
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        <span
          className="eye-icon"
          onClick={() => setShowPassword(!showPassword)}
        >
          {showPassword ? "🙈" : EyeIcon}
        </span>

        {errors.password && (
          <small className="error-text">{errors.password}</small>
        )}
      </div>

      {/* Confirm Password */}
      <div className="email-field password-wrapper">
        <label>Confirm Password</label>

        <input
          type={showConfirmPassword ? "text" : "password"}
          placeholder="Confirm Password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
        />

        <span
          className="eye-icon"
          onClick={() => setShowConfirmPassword(!showConfirmPassword)}
        >
          {showConfirmPassword ? "🙈" : EyeIcon}
        </span>

        {errors.confirmPassword && (
          <small className="error-text">{errors.confirmPassword}</small>
        )}
      </div>

      <div className="email-back" onClick={() => setEmailMode("login")}>
        ← Back
      </div>

      <button
        className="email-submit"
        onClick={handleSubmit}
        disabled={loading}
      >
        {loading ? <span className="spinner"></span> : "Signup →"}
      </button>
    </div>
  );
};

export default EmailSignup;
